export function digits(input) {
  return (input || '').replace(/[^0-9]+/g, '');
}
